import React from 'react';
import { Box} from '@mui/material';
import { Container, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';

import { stateValuesDos } from '../../Utils/Utils';

export default function UpdateEEForm(props) {

  return (
    <Box>
        <Container>
            <form id="update-ee-form" onSubmit={(e)=>{props.submitUpdatedEmployee(e)}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <h4 style={{textAlign:'center'}}>Update A {props.addWhatBranchTitle} Employee</h4>
                    </Grid>
                </Grid>
                <Grid container spacing={2} id="bank-select-grid">
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl sx={{width:"100%",mb:'5vh',mt:'5vh'}}>
                        <InputLabel id="hq-select-input-label">{props.addWhatBranchTitle} HQ To Select</InputLabel>
                        <Select
                            labelId="hq-select-input-label"
                            id="hq-select-input"
                            value={props.hqObjct.hq_id}
                            label="HeadQuarter"
                            onChange={(e)=>{
                                props.handleHQChange(e);
                            }}
                        >
                            <MenuItem value="">
                            <em>None</em>
                            </MenuItem>
                            {props.hqsToMap.map(hq =>{
                            return <MenuItem key={hq.hq_id} value={hq.hq_id}>{hq.hq_company_name}</MenuItem>

                            })}
                        </Select>
                        <FormHelperText>Select The {props.addWhatBranchTitle} The Branch is Associated With</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>

                {/*  */}
                <Grid container spacing={2} id="branch-select-grid" sx={{display:props.viewBranchField}}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl sx={{width:"100%",mb:'5vh',mt:'5vh'}}>
                        <InputLabel id="bank-select-input-label">Branch</InputLabel>
                        <Select
                            labelId="branch-select-input-label"
                            id="branch-select-input"
                            value={props.branchObjct.branch_id !== null ? props.branchObjct.branch_id:""} 
                            
                            label="Branch"
                            onChange={(e)=>{
                                props.handleChoosenBranchChange(e);
                            }}
                        >
                            <MenuItem key={"no_branch"} value="">
                            <em>None</em>
                            </MenuItem>
                            {props.hqObjct.branches.map(branch =>{
                            return <MenuItem key={branch.branch_id} value={branch.branch_id}>{branch.branch_name}</MenuItem>

                            })}
                        </Select>
                        <FormHelperText>Select The {props.addWhatBranchTitle} Branch The Employee is with</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>


                {/*  */}
                <Grid container spacing={2} id="ee-select-grid" sx={{display:props.viewEmployeeSelect}} >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl sx={{width:"100%",mb:'5vh',mt:'5vh'}}>
                        <InputLabel id="ee-select-input-label">Employee</InputLabel>
                        <Select
                            labelId="ee-select-input-label"
                            id="ee-select-input"
                            value={props.employeeObjct.user_id}
                            
                            label="Employee"
                            onChange={(e)=>{
                                props.handleChoosenEmployeeChange(e);
                                
                            }}
                        >
                            <MenuItem value="">
                            <em>None</em>
                            </MenuItem>
                            {props.branchObjct.branch_employees.map(ee =>{
                            return <MenuItem key={ee.user_id} value={ee.user_id}>{ee.first_name}</MenuItem>

                            })}
                        </Select>
                        <FormHelperText>Select The Employee To Update</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>

                <Container sx={{display:props.viewEEFields}}>

                    <Grid container spacing={2}  >
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard" error={props.errorValidator.first_name ? true:false}>
                                <InputLabel htmlFor="ee-first-name-input">First Name</InputLabel>
                                <Input id="ee-first-name-input"
                                        type={'text'}
                                        value={props.employeeObjct.first_name}
                                        onChange={e=>{props.handleFirstNameChange(e)}}/>
                                <FormHelperText id="usernamefield-error-text"
                                    sx={{
                                        display:props.errorValidator.first_name ? "block":"none",
                                    }}           
                                >Invalid First Name.</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard" error={props.errorValidator.last_name ? true:false}>
                                <InputLabel htmlFor="ee-first-name-input">Last Name</InputLabel>
                                <Input id="ee-first-name-input"
                                        type={'text'}
                                        value={props.employeeObjct.last_name}
                                        onChange={e=>{props.handleLastNameChange(e)}}/>
                                <FormHelperText id="usernamefield-error-text"
                                    sx={{
                                        display:props.errorValidator.last_name ? "block":"none",
                                    }}
                                                        
                                >Invalid Last Name.</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>


                        {/* <Grid container spacing={2} id="role-select-grid"> */}
                        <Grid item xs={12} sm={6} md={4} lg={4} >
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard" error={props.errorValidator.rle ? true:false}>
                            {/* sx={{mb:'5vh',mt:'5vh'}} */}
                            <InputLabel id="role-select-input-label">Role</InputLabel>
                            <Select
                                labelId="hq-select-input-label"
                                id="hq-select-input"
                                value={props.employeeObjct.rle}
                                label="Role"
                                onChange={(e)=>{
                                    props.handleRoleChange(e)
                                }}
                            >
                                <MenuItem value="">
                                <em>None</em>
                                </MenuItem>
                                {props.rolesToMap.map(role =>{
                                return <MenuItem key={role} value={role}>{role}</MenuItem>

                                })}
                            </Select>
                            <FormHelperText id="usernamefield-error-text"
                            sx={{
                                display:props.errorValidator.rle ? "block":"none",
                            }}
                                                
                            >A Role Needs to be selected.</FormHelperText>
                            {/* <FormHelperText>Select The Bank The Branch is Associated With</FormHelperText> */}
                            </FormControl>
                        </Grid>
                    {/* </Grid> */}



                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard" error={props.errorValidator.username ? true:false}>
                                <InputLabel htmlFor="ee-first-name-input">Username</InputLabel>
                                <Input id="ee-first-name-input"
                                        type={'text'}
                                        value={props.employeeObjct.username}
                                        onChange={e=>{props.handleUserNameChange(e)}}/>
                                <FormHelperText id="usernamefield-error-text"
                                    sx={{
                                        display:props.errorValidator.username ? "block":"none",
                                    }}
                                                    
                                >Invalid Username.</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard" error={props.errorValidator.passwrd ? true:false}>
                                <InputLabel htmlFor="ee-first-name-input">Password</InputLabel>
                                <Input id="ee-first-name-input"
                                        type={'text'}
                                        value={props.employeeObjct.passwrd}
                                        onChange={e=>{props.handlePasswordChange(e)}}/>
                                <FormHelperText id="usernamefield-error-text"
                                    sx={{
                                        display:props.errorValidator.passwrd ? "block":"none",
                                    }}
                                                        
                                >Invalid Password.</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>



                    <Grid container spacing={2} id="contact-info">
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                                    <InputLabel htmlFor="ee-email-input">Email</InputLabel>
                                    <Input 
                                    id="ee-email-input" 
                                    type={'text'} 
                                    value={props.employeeObjct.email} 
                                    onChange={e=>{props.handleEmailChange(e)}}/>
                                </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                                <InputLabel htmlFor="ee-phone-input">Phone</InputLabel>
                                <Input 
                                id="ee-phone-input" 
                                type={'text'} 
                                value={props.employeeObjct.phone} 
                                onChange={e=>{props.handlePhoneChange(e)}}/>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6} id="ee_address">
                        <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                            <InputLabel htmlFor="address-input">Address</InputLabel>
                            <Input 
                                id="address-input" 
                                type={'text'}
                                value={props.employeeObjct.address.address}
                                onChange={e=>{props.handleAddressChange(e)}}/>
                        </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} id="ee_address_two">
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                                <InputLabel htmlFor="ee-address-two-input">Address 2</InputLabel>
                                <Input 
                                id="ee-address-two-input" 
                                type={'text'} 
                                value={props.employeeObjct.address.address_two}
                                onChange={e=>{props.handleAddressTwoChange(e)}}/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} id="ee_city">
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                                <InputLabel htmlFor="ee-address-city-input">City</InputLabel>
                                <Input 
                                id="ee-address-city-input" 
                                type={'text'} 
                                value={props.employeeObjct.address.city} 
                                onChange={e=>{props.handleCityChange(e)}}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} id="ee_state_autocomplete">
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                            <Autocomplete
                            id="ee-state-input"
                            value={props.stateValue}
                            options={stateValuesDos}
                            getOptionLabel={(option) => option.index || ""}
                            renderOption={(props, option) => (
                                <Box component="li" {...props}>
                                {option.index} - {option.fullName}
                                </Box>
                            )}
                            isOptionEqualToValue={(option, value) => option.index === value.index}
                            onChange={(event, newValue) => {

                                // stateValue={stateValue}
                                props.setStateValue(newValue); // new value set for the autocomplete
                                
                                // ={setStateInputValue}
                                // setValue(newValue); 
                                props.handleStateChange(newValue); // value set in inspectionObject
                            }}
                            inputValue={props.stateInputValue}
                            onInputChange={(event, newInputValue) => {
                                // setInputValue(newInputValue);
                                props.setStateInputValue(newInputValue);
                            }}
                            renderInput={(params) => (
                            <TextField {...params} label="State" variant="standard" />
                            )}
                            />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} id="ee-address-zip-grid">
                            <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                                <InputLabel htmlFor="bank-branch-address-zip-input">Zip</InputLabel>
                                <Input id="bank-branch-address-zip-input" 
                                value={props.employeeObjct.address.zip} type={'text'} 
                                onChange={e=>{props.handleZipChange(e)}}/>
                            </FormControl>
                        </Grid>
                    </Grid>
    
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl sx={{ m: 1 }} variant="standard">
                            <Button variant='contained' type="submit">Submit</Button>
                            {/* onClick={e => props.submitUpdatedEmployee(e)} */}
                        </FormControl>
                        </Grid>
                    </Grid>
                </Container>
            </form>

          
        </Container>


    </Box>
  )
}
